import { ProfileLanguage } from 'components/profileMyCompanySection/MyCompanyForm/myCompanyForm.types';
import {
  ProfileOrder,
  ProfilePublishPayload,
  ProfileTypes
} from 'containers/NewProfile/newProfile.types';
import {
  CREATE_PROFILE_SNAPSHOT,
  PROFILE_FETCH_START,
  PROFILE_ORDER_START,
  PUBLISH_PROFILE_START,
  ProfileOrderAction,
  SET_PROFILE_LANGUAGE,
  SET_PROFILE_PREVIEW_TYPE,
  SetProfileLanguageAction,
  SetProfilePreviewTypeAction,
  TOGGLE_PREVIEW_MODAL,
  TOGGLE_SUBSECTION_EDITING_IN_PROGRESS,
  UNHIDE_PROFILE_START
} from './types';

const profileActions = {
  toggleSubsectionEditing: (payload: boolean) => ({
    type: TOGGLE_SUBSECTION_EDITING_IN_PROGRESS,
    payload,
  }),
  togglePreviewModal: (payload: boolean) => ({
    type: TOGGLE_PREVIEW_MODAL,
    payload,
  }),
  fetchProfile: (payload: { id: number }) => ({
    type: PROFILE_FETCH_START,
    payload,
  }),
  setProfilePreviewType: (payload: ProfileTypes): SetProfilePreviewTypeAction => ({
    type: SET_PROFILE_PREVIEW_TYPE,
    payload,
  }),
  setProfileLanguage: (payload: ProfileLanguage): SetProfileLanguageAction => ({
    type: SET_PROFILE_LANGUAGE,
    payload,
  }),
  orderProfile: (payload: ProfileOrder): ProfileOrderAction => ({
    type: PROFILE_ORDER_START,
    payload,
  }),
  publishProfile: (payload: ProfilePublishPayload) => ({
    type: PUBLISH_PROFILE_START,
    payload,
  }),
  unhideProfile: () => ({
    type: UNHIDE_PROFILE_START,
  }),
  createProfileSnapshot: () => ({
    type: CREATE_PROFILE_SNAPSHOT,
  }),
};

export default profileActions;
